import { InfoWithLabel } from "@/core/components/info-with-label";
import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { useGetActivityCustomer } from "@/activity-feed/query";
import { formatPhoneNumber } from "@/core/utils/phone";
import { getCustomerNameOrPhone } from "@/customer/utils";
import { ISpiff, CustomerTrigger } from "@/spiffs/spiffs.d";

interface CustomerTriggerDetailsProps {
  spiff: ISpiff;
}

export const CustomerTriggerDetails = ({
  spiff,
}: CustomerTriggerDetailsProps) => {
  const customerTrigger = spiff.trigger as CustomerTrigger;
  const { data: customer, isLoading } = useGetActivityCustomer(
    customerTrigger.id,
  );

  if (isLoading) {
    return (
      <Stack gap="sm" fullWidth>
        <InfoWithLabel label="Customer">
          <Skeleton className="h-5 w-48" />
        </InfoWithLabel>
        <InfoWithLabel label="Phone">
          <Skeleton className="h-5 w-40" />
        </InfoWithLabel>
      </Stack>
    );
  }

  if (!customer) {
    return (
      <InfoWithLabel label="Customer">
        <Typography variant="bodyW1" textColor="secondary">
          Customer information unavailable
        </Typography>
      </InfoWithLabel>
    );
  }

  return (
    <Stack gap="sm" fullWidth>
      <InfoWithLabel label="Customer">
        {getCustomerNameOrPhone(customer)}
      </InfoWithLabel>
      <InfoWithLabel label="Phone">
        {formatPhoneNumber(customer.phone_number)}
      </InfoWithLabel>
    </Stack>
  );
};
